/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIResponseBase,
  AnonymousPersonCreateReq,
  PostPersonsAnonymous201Response,
  PostPersonsPersonIdImpersonate201Response,
  PostPersonsPersonIdImpersonateV2Request,
} from '../models';
import {
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
    AnonymousPersonCreateReqFromJSON,
    AnonymousPersonCreateReqToJSON,
    PostPersonsAnonymous201ResponseFromJSON,
    PostPersonsAnonymous201ResponseToJSON,
    PostPersonsPersonIdImpersonate201ResponseFromJSON,
    PostPersonsPersonIdImpersonate201ResponseToJSON,
    PostPersonsPersonIdImpersonateV2RequestFromJSON,
    PostPersonsPersonIdImpersonateV2RequestToJSON,
} from '../models';

export interface PostPersonsAnonymousRequest {
    slashIDOrgID: string;
    anonymousPersonCreateReq: AnonymousPersonCreateReq;
    slashIDSdkVersion?: string;
}

export interface PostPersonsPersonIdImpersonateRequest {
    personId: string;
    slashIDOrgID: string;
}

export interface PostPersonsPersonIdImpersonateV2OperationRequest {
    personId: string;
    slashIDOrgID: string;
    postPersonsPersonIdImpersonateV2Request?: PostPersonsPersonIdImpersonateV2Request;
}

/**
 * 
 */
export class PersonsApi extends runtime.BaseAPI {

    /**
     * Create a new anonymous person linked to your organization. Unlike regular persons, anonymous persons\' identities are unknown and they do not have any authentication methods. However, it is still possible to persist information associated with this user, including attributes and GDPR consent. Anonymous persons can be created when a user first enters your website or application. If the person eventually signs up, the person type is upgraded to regular. Anonymous persons are inherently temporary and will be deleted after 30 days. Anonymous persons do not count towards billing and account limits, but their creation is rate-limited based on the organization\'s pricing tier. 
     * Create new anonymous person
     */
    async postPersonsAnonymousRaw(requestParameters: PostPersonsAnonymousRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostPersonsAnonymous201Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling postPersonsAnonymous.');
        }

        if (requestParameters.anonymousPersonCreateReq === null || requestParameters.anonymousPersonCreateReq === undefined) {
            throw new runtime.RequiredError('anonymousPersonCreateReq','Required parameter requestParameters.anonymousPersonCreateReq was null or undefined when calling postPersonsAnonymous.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/persons/anonymous`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AnonymousPersonCreateReqToJSON(requestParameters.anonymousPersonCreateReq),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPersonsAnonymous201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new anonymous person linked to your organization. Unlike regular persons, anonymous persons\' identities are unknown and they do not have any authentication methods. However, it is still possible to persist information associated with this user, including attributes and GDPR consent. Anonymous persons can be created when a user first enters your website or application. If the person eventually signs up, the person type is upgraded to regular. Anonymous persons are inherently temporary and will be deleted after 30 days. Anonymous persons do not count towards billing and account limits, but their creation is rate-limited based on the organization\'s pricing tier. 
     * Create new anonymous person
     */
    async postPersonsAnonymous(requestParameters: PostPersonsAnonymousRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostPersonsAnonymous201Response> {
        const response = await this.postPersonsAnonymousRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */
    async postPersonsPersonIdImpersonateRaw(requestParameters: PostPersonsPersonIdImpersonateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostPersonsPersonIdImpersonate201Response>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling postPersonsPersonIdImpersonate.');
        }

        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling postPersonsPersonIdImpersonate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/persons/{person_id}/impersonate`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPersonsPersonIdImpersonate201ResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */
    async postPersonsPersonIdImpersonate(requestParameters: PostPersonsPersonIdImpersonateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostPersonsPersonIdImpersonate201Response> {
        const response = await this.postPersonsPersonIdImpersonateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */
    async postPersonsPersonIdImpersonateV2Raw(requestParameters: PostPersonsPersonIdImpersonateV2OperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostPersonsPersonIdImpersonate201Response>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling postPersonsPersonIdImpersonateV2.');
        }

        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling postPersonsPersonIdImpersonateV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/persons/{person_id}/impersonate/v2`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostPersonsPersonIdImpersonateV2RequestToJSON(requestParameters.postPersonsPersonIdImpersonateV2Request),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPersonsPersonIdImpersonate201ResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */
    async postPersonsPersonIdImpersonateV2(requestParameters: PostPersonsPersonIdImpersonateV2OperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostPersonsPersonIdImpersonate201Response> {
        const response = await this.postPersonsPersonIdImpersonateV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
